import { render } from "./LedgerLoadMoreTable.vue?vue&type=template&id=5cb95f94"
import script from "./LedgerLoadMoreTable.vue?vue&type=script&lang=js"
export * from "./LedgerLoadMoreTable.vue?vue&type=script&lang=js"

import "./LedgerLoadMoreTable.vue?vue&type=style&index=0&id=5cb95f94&lang=css"

import exportComponent from "/app/vue-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__